export const getPrefixCls = (suffix: string) => `custom-chat-${suffix}`;
